export default "__VITE_ASSET__CqftQ0Pr__"